export default __webpack_public_path__ + "static/media/ni.b75b50ce.svg";